<template>
  <TooltipWrapper class="w-full" :z-index="50">
    <template #trigger>
      <div class="blur-xs">
        <div v-if="props.cellType === 'rating'" class="flex items-center">
          <RatingStars :value="ratingValue" />
          <span class="ml-1">{{ ratingText }}</span>
        </div>
        <span v-else-if="props.cellType">{{ mockData }}</span>
        <slot />
      </div>
    </template>
    <template #content>
      <div v-html="t('Reviews.product.view.table.fencedCell.Tooltip.text')"></div>
    </template>
  </TooltipWrapper>
</template>

<script setup lang="ts">
import { RatingStars, TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

type CellType = 'date' | 'name' | 'company' | 'campaign' | 'rating' | 'purpose'

const props = defineProps<{
  cellType?: CellType
}>()

const { t } = useI18n()

const mockData = computed(() => {
  switch (props.cellType) {
    case 'date':
      return generateRandomDate()
    case 'name':
      return generateRandomName()
    case 'company':
      return generateRandomCompany()
    case 'campaign':
      return generateRandomCampaign()
    case 'purpose':
      return generateRandomPurpose()
    default:
      return ''
  }
})

const ratingValue = computed(() => {
  const randomScore = Math.floor(Math.random() * 11)
  return randomScore / 2
})

const ratingText = computed(() => {
  return ratingValue.value.toFixed(1)
})

function generateRandomDate(): string {
  const randomDate = new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000)
  return randomDate.toLocaleDateString()
}

function generateRandomName(): string {
  const names = ['John D.', 'Sarah M.', 'Michael R.', 'Emma K.', 'David L.', 'Lisa W.']
  return names[Math.floor(Math.random() * names.length)]
}

function generateRandomCompany(): string {
  const companies = ['Company A', 'Enterprise B', 'Corp C', 'Solutions D', 'Systems E']
  return companies[Math.floor(Math.random() * companies.length)]
}

function generateRandomCampaign(): string {
  const campaigns = ['DE Campaign', 'EN Campaign']
  return campaigns[Math.floor(Math.random() * campaigns.length)]
}

function generateRandomPurpose(): string {
  const purposes = ['Category A', 'Category B', 'Category C', 'Category D', 'Category E']
  return purposes[Math.floor(Math.random() * purposes.length)]
}
</script>
